import { useState, useEffect } from "react";
import axios from "axios";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import API_BASE_URL from "../../config";

const _base = process.env.REACT_APP_BACKEND_URL || API_BASE_URL;
const API = _base.endsWith('/api') ? _base : `${_base}/api`;

export default function LikeButton({ post, user }) {
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (post) {
      setLikeCount(post.like_count || 0);
      if (user && post.likes) {
        setLiked(post.likes.includes(user.id));
      }
    }
  }, [post, user]);

  const handleLike = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!user || user === false) {
      toast.error("Please log in to like posts");
      return;
    }

    if (loading) return;

    // Optimistic Update
    const previousLiked = liked;
    const previousCount = likeCount;

    setLiked(!previousLiked);
    setLikeCount((prev) => (previousLiked ? Math.max(0, prev - 1) : prev + 1));
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      console.log("TOKEN:", token);
      const headers = token ? { 
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}` 
      } : {
        "Content-Type": "application/json"
      };
      const endpoint = previousLiked ? "unlike" : "like";
      const { data } = await axios.post(`${API}/posts/${post.id}/${endpoint}`, {}, { 
        withCredentials: true,
        headers 
      });
      // Sync with server state
      setLiked(data.liked);
      setLikeCount(data.like_count);
    } catch (err) {
      // Revert on error
      setLiked(previousLiked);
      setLikeCount(previousCount);
      toast.error("Failed to update like");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleLike}
      disabled={loading}
      className={`flex items-center gap-1.5 transition-colors p-1.5 rounded-lg ${
        liked ? "text-red-500 bg-red-50" : "text-[#5C6B64] hover:text-red-500 hover:bg-red-50"
      }`}
      data-testid={`like-btn-${post.id}`}
      aria-label={liked ? "Unlike post" : "Like post"}
    >
      <Heart className={`w-5 h-5 ${liked ? "fill-current" : ""}`} strokeWidth={1.5} />
      <span className="text-sm font-medium">{likeCount}</span>
    </button>
  );
}
